import { Link } from 'react-router-dom'
import { FaAngleLeft } from "react-icons/fa";
import { useSelector } from 'react-redux'
import { useRef } from "react";

import NoBody from 'assets/images/no-avatar.png'
import { authSelector } from 'redux/selector'
import { AdminHeaderWrapper } from "./styled"

const AdminHeader = () => {

    const authState = useSelector(authSelector)
    const avatarRef = useRef()

    const handleErrorAvatar = () => {
        avatarRef.current.src = NoBody
    }
    return (
        <AdminHeaderWrapper className='bg-color7'>
            <div className='admin_header_redirect_home text-link'>
                <i><FaAngleLeft /></i>
                <Link className='text-link' to="/">Về trang chủ</Link>
            </div>
            <div className='admin_header_user'>
                <div>
                    <img
                        src={authState.currentUser.user?.avatar || NoBody}
                        alt='avatar'
                        ref={avatarRef}
                        onError={handleErrorAvatar}
                    />
                </div>
                <span className='text-red'>
                    {
                        authState.currentUser.user.account_name
                    }
                </span>
            </div>
        </AdminHeaderWrapper>
    );
}

export default AdminHeader;
